export function scrollToElement(id) {
  setTimeout(() => {
    const element = document.getElementById(id);
    if (!element) return;
    const elementPosition = element.getBoundingClientRect().top;
    const offsetPosition = elementPosition + window.pageYOffset - 50;
    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth"
    });
  }, 800);
}
;